import styles from "./TransactionHeader.module.css";
import { SkeletonLoader } from "@pepperstone/pepper-ui-kit";

/* Loading skeleton for the transaction header
  This component displays a skeleton loader while the transaction data is being fetched.
  @returns A ReactElement representing the loading skeleton for the TransactionHeader.
*/
export const TransactionHeaderLoadingSkeleton = () => {
  return (
    <>
      <h2 className={styles.transactionHeaderTitle}>
        <SkeletonLoader
          height={6}
          rounding="sm"
          variant="rectangular"
          extraClasses={styles["title-loader"]}
        />
      </h2>
      <div className={styles.transactionAmountandStatus}>
        <SkeletonLoader
          rounding="sm"
          variant="rectangular"
          extraClasses={styles["amount-loader"]}
        />
        <SkeletonLoader
          height={8}
          rounding="sm"
          variant="rectangular"
          extraClasses={styles["status-loader"]}
        />
      </div>
      <div className={styles.transactionDetails}>
        <div className={styles.fromAccount}>
          <p>
            <SkeletonLoader
              width={10}
              height={5}
              rounding="sm"
              variant="rectangular"
            />
          </p>
          <div className={styles["account-details"]}>
            <SkeletonLoader width={5} height={5} variant="circular" />
            <SkeletonLoader
              width={20}
              height={5}
              rounding="sm"
              variant="rectangular"
            />
          </div>
        </div>
        <div className={styles.toAccount}>
          <p>
            <SkeletonLoader
              width={10}
              height={5}
              rounding="sm"
              variant="rectangular"
            />
          </p>
          <div className={styles["account-details"]}>
            <SkeletonLoader width={5} height={5} variant="circular" />
            <SkeletonLoader
              width={20}
              height={5}
              rounding="sm"
              variant="rectangular"
            />
          </div>
        </div>
      </div>
    </>
  );
};
